import {atom} from 'jotai'

import {ContractFormFieldErrors} from './types'

export const contractSetupFormFieldErrorsAtom = atom<string[]>([])
export const customerFormFieldErrorsAtom = atom<string[]>([])
export const extraCostsFormFieldErrorsAtom = atom<string[]>([])
export const productFormFieldErrorsAtom = atom<string[][]>([[]])

export const formDataErrorsAtom = atom<ContractFormFieldErrors>(get => ({
  contractSetupFormFieldErrors: get(contractSetupFormFieldErrorsAtom),
  customerFormFieldErrors: get(customerFormFieldErrorsAtom),
  extraCostsFormFieldErrors: get(extraCostsFormFieldErrorsAtom),
  productFormFieldErrors: get(productFormFieldErrorsAtom),
}))
